import { IconProps } from './index';

const AddFill = ({ title, titleId, ...props }: React.SVGProps<SVGSVGElement> & IconProps) => {
    return (
        <svg
            width={14}
            height={14}
            viewBox="0 0 14 14"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-labelledby={titleId}
            {...props}
        >
            {title ? <title id={titleId}>{title}</title> : null}
            <path d="M6 6V0h2v6h6v2H8v6H6V8H0V6h6z" fill="currentColor" />
        </svg>
    );
};

export default AddFill;
